"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildVideoPayload;

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var OMITTED_KEYS = ['videoId', 'organisationId', 'videoProjectId', 'createdByUserId', 'outputs', 'creator', 'submittedAt', 'createdAt', 'updatedAt', '__typename'];

function updatePlayableClips(video) {
  var clips = video.clips;
  var newClips = clips.map(function (clip) {
    var clipId = clip.clipId,
        __typename = clip.__typename,
        clipProps = _objectWithoutProperties(clip, ["clipId", "__typename"]);

    if (clipId.indexOf('clip') === 0) {
      return clipProps;
    }

    return (0, _lodash.default)(clip, '__typename');
  });
  return _objectSpread({}, video, {
    clips: newClips
  });
}

function updatePresenters(video) {
  var presenters = video.presenters;
  var newPresenters = presenters.map(function (presenter) {
    return (0, _lodash.default)(presenter, ['imageUrl', 'organisationId']);
  });
  return _objectSpread({}, video, {
    presenters: newPresenters
  });
}

function buildVideoPayload(video) {
  return (0, _lodash.default)(updatePresenters(updatePlayableClips(video)), OMITTED_KEYS);
}